import { TPlacePhone } from './get'


export const EDIT_PHONE_URL = 'v1/account/objects/:id/phones/:phoneId/'
export type EditPhoneReq = Partial<TPlacePhone>

export const EDIT_LINK_URL = 'v1/account/objects/:id/'
export type EditLinkReq = { site_url: string | null }
export type EditLinkResp = { site_url: string | null }